<script setup lang="ts">
import { BtnPrimary } from '@shared/ui/buttons'

import { useButtonFiltersSubmit } from '../../model/shift-control/button-filters-submit.hook'

defineOptions({
  name: 'ButtonFiltersSubmit',
})

const {
  text,
  disabled,
  setSubmit,
} = useButtonFiltersSubmit()
</script>

<template>
  <BtnPrimary
    :text="text"
    :disabled="disabled"
    element-width="auto"
    @click="setSubmit"
  />
</template>
